<template>
  <div class="home">
    <div class="banner">
      <div class="container">
        <div class="title">云蜂树智</div>
        <div class="des">
          <p>云端超强GPU超算中心</p>
          <p>服务深度学习、科学计算、生物基因等前沿科技</p>
          <p>云游戏追求极致体验的动力之源</p>
        </div>
      </div>
    </div>
    <div class="session-1">
      <div class="container">
        <div class="row">
          <div class="left col-sm-6">
            <div class="title">GPU并行算力驱动智能应用发展，超算中心+边缘计算为云边协同提供强劲算力</div>
            <p class="des">云蜂树智通过超级超算中心及高算力的边缘计算节点为AI人工智能、云游戏、云渲染、云转码等重度计算应用提供超高性价比的云计算服务。云蜂树智还服务了金融、工业、生命科学、能源、智慧城市等行业的大数据分析和智能制造。</p>
            <div class="icons">
              <div class="icon-item">
                <img src="@/assets/images/home/r_hone_icon_01.png">
                <p>云游戏</p>
              </div>
              <div class="icon-item">
                <img src="@/assets/images/home/r_hone_icon_02.png">
                <p>人工智能</p>
              </div>
              <div class="icon-item">
                <img src="@/assets/images/home/r_hone_icon_03.png">
                <p>大数据分析</p>
              </div>
              <div class="icon-item">
                <img src="@/assets/images/home/r_hone_icon_04.png">
                <p>渲染农场</p>
              </div>
            </div>
          </div>
          <div class="right col-sm-6"><img class="img-responsive pull-right" src="@/assets/images/home/r_hone_illustration03.png" alt=""></div>
        </div>
      </div>
    </div>
    <div class="session-2">
      <div class="container">
        <div class="row">
          <div class="left col-sm-6">
            <img src="@/assets/images/home/r_hone_images_01.png" alt="">
          </div>
          <div class="right col-sm-6">
            <div class="list">
              <div class="list-item">
                <img src="@/assets/images/home/r_hone_icon_05.png">
                <div class="des">
                  <div class="title">超高性价比</div>
                  <p>采用以包月包年的按需付费用模式，无需一次性投入，享受专属服务，有效降低投入硬件成本和运维成本。</p>
                </div>
              </div>
              <div class="list-item">
                <img src="@/assets/images/home/r_hone_icon_06.png">
                <div class="des">
                  <div class="title">性能怪兽</div>
                  <p>特殊硬件工艺定制的GPU服务器，密度超高，算力单机爆表，是CPU百倍的计算能力，完成大规模计算游刃有余。</p>
                </div>
              </div>
              <div class="list-item">
                <img src="@/assets/images/home/r_hone_icon_07.png">
                <div class="des">
                  <div class="title">使用便捷</div>
                  <p>一站式服务集成，即开即用，一键简单部署,同一镜像可在多台服务中快速复制环境，轻松伸缩，网络存储自动打通，无须额外配置。</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="session-3">
      <div class="container">
        <div class="row">
          <div class="left col-sm-6">
            <div class="title">借助GPU推动人工智能发展</div>
            <p class="des">服务人工智能场景，搭建了大规模的AI计算集群，提供了从硬件到定制化系统设计的全链路解决方案。帮助企业本地AI计算资源轻松上云，为团队提供稳定易用的AI训练平台，解决深度学习以及海量标签数据自动训练的效率问题。</p>
          </div>
          <div class="right col-sm-6"><img class="pull-right" src="@/assets/images/home/r_hone_illustration04.png" alt=""></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Home',
  components: {
  },
};
</script>

<style lang="scss" scoped>
.banner{
  background: url('../assets/images/home/r_hone_banner.png') no-repeat;
  background-size: cover;
  height: 500px;
  color: #fff;
  overflow: hidden;
  .title{
    font-size: 34px;
    font-weight: bold;
    margin-top: 109px;
  }
  .des{
    margin-top: 24px;
    p{
      color: #A2A2BB;
      font-size: 18px;
      font-weight: bold;
      & + p{
        margin-top: 18px;
      }
    }
  }
}
@media (max-width: $screen-sm-min) {
  .banner{
    height: 400px;
    .title{
      margin-top: 88px;
    }
    .des{
      p{
        font-size: 16px;
      }
    }
  }
}
.session-1{
  padding: 42px 0;
  .left{
    .title{
      font-size: 24px;
      font-weight: bold;
      margin-top: 50px;
    }
    .des{
      font-size: 14px;
      margin-top: 30px;
    }
    .icons{
      display: flex;
      justify-content: space-between;
      margin-top: 63px;
      .icon-item{
        text-align: center;
        img{
          width: 56px;
          height: 56px;
        }
        p{
          font-size: 14px;
          margin-top: 7px;
          font-weight: bold;
        }
      }
    }
  }
  .right{
    text-align: right;
    img{
      width: 100%;
      max-width: 400px;
    }
  }
}
@media (max-width: $screen-sm-min) {
  .session-1{
    padding: 0;
    .right{
      margin-top: 20px;
      img{
        float: none !important;
        max-width: none;
      }
    }
  }
}
.session-2{
  padding: 98px 0;
  background-color: #000000;
  .left{
    img{
      width: 100%;
      max-width: 646px;
    }
  }
  .right{
    .list{
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .list-item{
        display: flex;
        img{
          flex: none;
          width: 80px;
          height: 80px;
          display: block;
        }
        .des{
          flex: 1;
          margin-left: 20px;
          .title{
            font-size: 18px;
            font-weight: bold;
            color: #fff;
          }
          p{
            color: #A2A2BB;
            font-size: 14px;
            margin-top: 14px;
          }
        }
        & + .list-item{
          margin-top: 57px;
        }
      }
    }
  }
}
@media (max-width: $screen-sm-min) {
  .session-2{
    padding: 20px 0;
    .right{
      margin-top: 20px;
      .list{
        .list-item{
          & + .list-item{
            margin-top: 20px;
          }
          .des{
            p{
              margin-top: 6px;
            }
          }
        }
      }
    }
  }
}
.session-3{
  padding: 100px 0;
  .left{
    .title{
      font-size: 24px;
      font-weight: bold;
      margin-top: 53px;
    }
    .des{
      font-size: 14px;
      margin-top: 30px;
    }
  }
  .right{
    text-align: right;
    img{
      width: 100%;
      max-width: 441px;
    }
  }
}
@media (max-width: $screen-sm-min) {
  .session-3{
    padding: 20px 0;
    .left{
      .title{
        margin-top: 0;
      }
    }
    .right{
      margin-top: 20px;
      img{
        float: none !important;
        max-width: none;
      }
    }
  }
}
</style>
